// ─── Card 1: Diagnostic Shuffler ─────────────────────────────────
function initShuffler() {
  const stage = document.getElementById("shufflerStage");
  if (!stage) return;

  const items = Array.from(stage.querySelectorAll(".features__shuffler-item"));

  function cycle() {
    // array.unshift(array.pop()) logic: pos 2 → 0, pos 0 → 1, pos 1 → 2
    items.forEach((item) => {
      const pos = parseInt(item.dataset.pos);
      item.dataset.pos = (pos + 1) % 3;
    });
  }

  setInterval(cycle, 3000);
}

// ─── Card 2: Telemetry Typewriter ────────────────────────────────
function initTypewriter() {
  const textEl = document.getElementById("typewriterText");
  if (!textEl) return;

  const messages = [
    "Farbpalette wird kalibriert...",
    "UI-Komponenten strukturiert.",
    "Typografie optimiert.",
    "Grid-System: 12 Spalten aktiv.",
    "Responsive-Breakpoints gesetzt.",
    "Prototyp bereit für Review.",
    "Design-System exportiert.",
  ];

  let msgIndex = 0;
  let charIndex = 0;
  let isDeleting = false;

  function tick() {
    const msg = messages[msgIndex];

    if (!isDeleting) {
      charIndex++;
      textEl.textContent = msg.slice(0, charIndex);

      if (charIndex === msg.length) {
        isDeleting = true;
        setTimeout(tick, 2400);
        return;
      }
    } else {
      charIndex--;
      textEl.textContent = msg.slice(0, charIndex);

      if (charIndex === 0) {
        isDeleting = false;
        msgIndex = (msgIndex + 1) % messages.length;
        setTimeout(tick, 450);
        return;
      }
    }

    setTimeout(tick, isDeleting ? 32 : 58);
  }

  setTimeout(tick, 1000);
}

// ─── Card 3: Cursor Protocol Scheduler ───────────────────────────
function initScheduler() {
  const wrapper = document.getElementById("schedulerWrapper");
  const cursor = document.getElementById("schedulerCursor");
  const saveBtn = document.getElementById("schedulerSave");
  const grid = document.getElementById("weekGrid");
  if (!wrapper || !cursor || !saveBtn || !grid) return;

  const days = Array.from(grid.querySelectorAll(".features__day"));
  const targetIndices = [0, 2, 4]; // Mo, Mi, Fr

  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function getPos(el) {
    const wRect = wrapper.getBoundingClientRect();
    const eRect = el.getBoundingClientRect();
    return {
      x: eRect.left - wRect.left + eRect.width / 2 - 9,
      y: eRect.top - wRect.top + eRect.height / 2 - 4,
    };
  }

  function moveTo(x, y) {
    cursor.style.transform = `translate(${x}px, ${y}px)`;
  }

  async function runSequence() {
    const firstPos = getPos(days[targetIndices[0]]);

    // Appear slightly offset from first target
    cursor.style.transition = "none";
    moveTo(firstPos.x - 36, firstPos.y + 18);
    void cursor.offsetWidth; // force reflow
    cursor.style.transition = "";

    cursor.style.opacity = "1";
    await delay(300);

    // Click each target day
    for (const idx of targetIndices) {
      const day = days[idx];
      const pos = getPos(day);
      moveTo(pos.x, pos.y);
      await delay(560);

      day.classList.add("features__day--pressing");
      await delay(130);
      day.classList.remove("features__day--pressing");
      day.classList.add("features__day--active");
      await delay(280);
    }

    // Move to save button
    const savePos = getPos(saveBtn);
    moveTo(savePos.x, savePos.y);
    await delay(560);

    saveBtn.classList.add("features__save-btn--pressing");
    await delay(130);
    saveBtn.classList.remove("features__save-btn--pressing");
    saveBtn.classList.add("features__save-btn--saved");
    await delay(1800);

    // Fade out
    cursor.style.opacity = "0";
    await delay(400);

    // Silently reset position while invisible
    cursor.style.transition = "none";
    moveTo(firstPos.x - 36, firstPos.y + 18);
    void cursor.offsetWidth;
    cursor.style.transition = "";

    // Reset card states
    days.forEach((d) =>
      d.classList.remove("features__day--active", "features__day--pressing")
    );
    saveBtn.classList.remove(
      "features__save-btn--saved",
      "features__save-btn--pressing"
    );

    await delay(1200);
    runSequence();
  }

  // Start only when card enters viewport
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          observer.disconnect();
          setTimeout(runSequence, 800);
        }
      });
    },
    { threshold: 0.5 }
  );

  observer.observe(wrapper);
}

export function initFeatures() {
  initShuffler();
  initTypewriter();
  initScheduler();
}
